import React, { useState,useRef, useEffect } from 'react';
import { NavLink, useLocation  } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { language } from './Language';
import { getTokenInfo } from '../../../UseToken';
import { confirmAlert } from 'react-confirm-alert';
import Select from 'react-select';
import Swal from 'sweetalert2'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

import * as Utils from '../../../Utils';

import Company from './Init';
//import { result } from 'lodash';


export default function Regist() {
    const navigate = useHistory();
    
    const [lang,] = useState(Utils.get_language());
    const location = useLocation()
    const props = location.state
    //confirmAlert(options);

    const [, set_dados] = useState(null);

    const dados = useRef(null);

    const [isloading, setLoading] = useState(true);

    const [is_edit, set_is_edit] = useState(false)

    //const [password_changed, set_password_changed] = useState(false)
    const [show_vat_form, set_show_vat_form] = useState('');
    const [, set_show_delete_button] = useState('d-none');
    //const [show_delete_button, set_show_delete_button] = useState(false);

    const [show_district_city_village, set_show_district_city_village] = useState('');


    //Temporário

    const [countries, set_countries] = useState([])
    const [districts, set_districts] = useState([])
    const [cities, set_cities] = useState([])
    const [villages, set_villages] = useState([])




    const custom_select_styles = {
        container: base => ({
            ...base,
            width: '100%',
        }),
        control: base => ({
            ...base,
            borderRadius: '10px',
            padding: '2px 10px',
            fontSize: '14px'
        }),
    }

    useEffect(() => {

        const fetch_id_info = async (id_serch) => {
            return await Utils.reqGET(Company.api_crud_route_search(getTokenInfo().companycode, id_serch))
                .then(res => 
                    {
                    //res.data[0]
                    let tmp = Utils.normalize_from_db_to_data_interface(Company.data_interface, res.data[0])
                        console.log(tmp)
                        set_dados(dados.current = tmp)
                    //set_dados(dados.current = res.data[0])
                    })
                    
                    
                    
                   
                .catch(error => alert(error))
        }

        const clean_data = () => {
            // DEEP COPY OF Company.data_interface 
            set_dados(dados.current = JSON.parse(JSON.stringify(Company.data_interface)))
            //set_dados(dados.current.permissions.companycode = getTokenInfo().companycode)
        }

        //set_save_label('Salvar')

        clean_data()

        Utils.obter_paises_em_pt(set_countries);

        if (props !== null) {

            let test = props.operation;

            if (test === 'edit') {

                set_show_vat_form('d-none')

                set_show_delete_button('')

                set_is_edit(true)

                fetch_id_info(props.item['id']).then(() => {

                    if (dados.current.addresses[0].country === 'Portugal') {

                        Utils.obter_distritos_pt(set_districts)

                        Utils.obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

                        Utils.obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
                        setLoading(false);
                    }
                    else {
                        set_show_district_city_village('d-none')
                        setLoading(false);
                    }

                   
                    setLoading(false)
                        

                })
            }

        } else {


            // PARA TESTE

            Utils.get_my_fact_company(getTokenInfo().companycode)
            .then(result=> {

               
                let tmp = Utils.normalize_from_db_to_data_interface(Company.data_interface, result)
                
              
                //console.log(tmp)
                //console.log('RESULTADO:', tmp)
                set_show_vat_form('d-none')
                set_dados(dados.current = tmp)
                //set_dados(dados.current = result)

                setLoading(false)
            })

            clean_data()
            setLoading(false)

             
        }

        return () => { }

    }, [props])


    const handle_submit_vat = async e => {
        e.preventDefault();

        setLoading(true);
        Utils.get_vat_info(dados.current.info.vat)
            .then(res => {
                //console.log('---------- VAT INFO --------------')
                //console.log(res)

                if ((res.data.name !== '---') && (res.data.name !== '')) {
                    //clean_data();
                    set_dados(dados.current.info.vat = res.data.vatNumber);
                    set_dados(dados.current.info.name = res.data.name);
                    set_dados(dados.current.info.company = res.data.name);
                    set_dados(dados.current.addresses[0].address_detail = res.data.address);

                    let aMorada = res.data.address.split("\n");
                    // Verificar se pais é PT
                    if (res.data.countryCode === 'pt') {
                        //console.log('----------------------> É PT')

                        change_country({ value: 'Portugal' })


                        set_dados(dados.current.addresses[0].street_name = aMorada[1]);

                        let city = aMorada[1];
                        if (city !== undefined) {
                            city = city.toLowerCase();
                            city = city.charAt(0).toUpperCase() + city.slice(1);
                            change_district_by_city({ value: city }).then(() => change_city({ value: city }))


                            // After District -> City
                            change_district_by_city({ value: city }).then(() => change_city({ value: city }))

                            let aMoradaCP = aMorada[2].split(" ");
                            set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
                        }
                    } else {
                        //console.log('---------------------->NÃO È PT')
                        set_dados(dados.current.addresses[0].street_name = aMorada[1]);
                    }
                }
                else {


                    confirmAlert({
                        title: 'Aviso',
                        message: 'VAT não encotrado na base VIES.',
                        buttons: [
                            {
                                label: 'Voltar',
                                onClick: () => { return }
                            }
                        ]
                    })
                }
                setLoading(false)
            })

            .catch(error => { setLoading(false); alert(error) });
    }

 


    const load_entity = async (field, value, entity) => {
        let search_string = ''

        if (entity === '') {
            search_string = `${Company.api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
        }
        else
            search_string = `${Company.api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

        Utils.reqGET(search_string)
            .then(res => {
                //console.log(res.data)

                let ja_existe = false
                res.data.forEach((k) => {
                    if (k[field] === value && value !== '') {

                        ja_existe = true
                    }
                })

                if (ja_existe === false) {
                    //set_is_input_disabled(true)

                    if (field === 'username') {
                        //set_is_input_disabled(false)
                    }
                    return

                } else {
                    //set_disabled(true)

                    Swal.fire({
                        title: language[lang].warning_title,
                        text: language[lang].warning_text,
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#0095e8',
                        cancelButtonColor: '#d9214e',
                        confirmButtonText: language[lang].warning_confirm,
                        cancelButtonText: language[lang].warning_cancel
                    })
                        .then((result) => {
                            if (result.isConfirmed) {
                                //set_is_input_disabled(true)
                                //set_disabled(false)
                                document.getElementById('username').style.color = 'red';
                            }
                        })

                }
            })
    }

  /*   const handle_change_login = (e) => {
        const { value } = e.target;

        load_entity('username', value, '')
    }

    const handle_change_password = (e) => {
        const { value } = e.target;

        if (dados.current.info.password !== '' && value === dados.current.info.password) {
            //set_disabled(false)
            set_password_changed(true)
        }
        else {

            Swal.fire({
                title: language[lang].password_title,
                text: language[lang].password_text,
                icon: 'error',
                confirmButtonColor: '#0095e8'
            })

            //alert('Password de confirmação diferente da password inserida')
            //set_disabled(true)
        }
    }

    const handleSingleCheckDarkmode = (e) => {
        if (dados.current.info['darkmode'] === true) {
            set_dados(dados.current.info['darkmode'] = false)
            //set_darkmode(false)
        }
        else {
            set_dados(dados.current.info['darkmode'] = true)
            //set_darkmode(true)
        }

        //console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
        //console.log('Dados Current:' + JSON.stringify(dados))
    } */

    let apagar= ()=> {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    Utils.reqDELETE(Company.api_crud_route + '/', { id: dados.current.id })
                        .then(res => {
                            navigate.push(Company.components.list.path);
                        })
                        .catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
                }
            })
    };


    const voltar = (title, msg, force_reload = false) => {

        confirmAlert({
            title: title,
            message: msg,
            buttons: [
                {
                    label: 'Voltar',
                    onClick: () => {

                        if (force_reload === true) {
                            window.location.reload()
                        } else
                            navigate.push(Company.components.list.path)

                    }
                },
            ]
        })
    }



    let handle_submit = async e => {
        e.preventDefault();

        //console.log('------------NO SUBMIT-------------')
        //let guardarNavLink = Company.components.list.path
        //console.log(Company.components.list.path)

       // if (is_edit === true) {

            //const data_interface_entities = companycode => `${Company.api_crud_base}/entities/special/list/${companycode}/${dados.current.name}`

            //console.log('dados.current.name:',dados.current.name)
            /* let entities_route = data_interface_entities(getTokenInfo().companycode)

            let temp_profile = {
                name: dados.current.name,
                companycode: dados.current.permissions.companycode,
                menu: dados.current.permissions.menu
            };
 */
            try {
                /* await Utils.reqGET(entities_route)
                    .then(res => {

                        console.log('NO SUBMIT 2')
                        console.log(res)

                        res.data.forEach(item => {

                            item.profile = temp_profile

                            //UPDATE ENTITY PROFILE 
                            Utils.reqPUT(`${Company.api_crud_route}`, item)
                                //.then(() => alert('Registo Atualizado com Sucesso! HAHA'))
                                .catch((e) => alert('Problema ao atualizar Registo!',e))
                        })
                    })
                    .catch(() => { alert('Problema ao atualizar Entidades!') }) */
                //console.log('TESTE:', dados.current)

               /*  if (password_changed === true){
                    let password = dados.current.info.password;
                    dados.current.info.password = Utils.passwordHash(password);
                } */


                Utils.reqPUT(Company.api_crud_route, dados.current)
                    .then(() => voltar('Edição', 'Registo Atualizado com Sucesso.', true))//alert('Registo Atualizado com Sucesso!'))
                    .catch(() => voltar('Edição', 'Problema ao Atualizar Registo!'))

            } catch {
                return
                //console.log('NO CATCH')
            }

        /*}  else {
            //console.log('---------------> NO POST')
            Utils.reqPOST(Company.api_crud_route, dados.current)
                .then(voltar('Novo Registo', 'Registo Introduzido com Sucesso'))
                .catch(voltar('Novo Registo', 'Problema ao Inserir Registo!'))
        } */
    }

/* 
    const handle_submit_password = async e => {
        e.preventDefault();

        Swal.fire({
            title: language[lang].edit_title,
            text: language[lang].edit_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].edit_confirm,
            cancelButtonText: language[lang].edit_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    Utils.reqPUT(Company.api_crud_route, dados.current)
                        .then(() => navigate(Company.components.list.path) )
                        .catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
                }
            })
    }


    const handle_submit_config = async e => {
        e.preventDefault();

        if (is_edit === true) {

            Swal.fire({
                title: language[lang].edit_title,
                text: language[lang].edit_text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0095e8',
                cancelButtonColor: '#d9214e',
                confirmButtonText: language[lang].edit_confirm,
                cancelButtonText: language[lang].edit_cancel
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        Utils.reqPUT(Company.api_crud_route, dados.current)
                            .then(() => navigate(Company.components.list.path))
                            .catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
                    }
                })

        } else {

            Swal.fire({
                title: language[lang].insert_title,
                text: language[lang].insert_text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0095e8',
                cancelButtonColor: '#d9214e',
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        let password = dados.current.info.password;
                        dados.current.info.password = Utils.passwordHash(password);

                        Utils.reqPOST(Company.api_crud_route, dados.current)
                            .then(() => navigate(Company.components.list.path))
                            .catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
                    }
                })

        }
    } */


    // ------------------------------------------------------------------------------------


    const change_country = e => {

        set_cities([])
        set_villages([])

        set_dados(dados.current.addresses[0].city = '');
        set_dados(dados.current.addresses[0].village = '');
        set_dados(dados.current.addresses[0].region = '');

        if (e.value === "Portugal") {

            set_show_district_city_village('')

            if (districts.length === 0) {
                //console.log('DISTRITOS VAZIOS')
                Utils.obter_distritos_pt(set_districts)
            }
        }
        else {
            set_show_district_city_village('d-none')
        }

        set_dados(dados.current.addresses[0].country = e.value);
    }

    const change_district = e => {

        set_cities([])
        set_villages([])

        Utils.obter_cidades_por_distrito(e.value, set_cities)

        set_dados(dados.current.addresses[0].city = '');
        set_dados(dados.current.addresses[0].village = '');
        set_dados(dados.current.addresses[0].region = e.value);
    }

    const change_city = e => {

        set_villages([])

        Utils.obter_freguesias_por_cidade(e.value, set_villages)

        set_dados(dados.current.addresses[0].village = '');
        set_dados(dados.current.addresses[0].city = e.value);
    }

    const change_village = e => {
        set_dados(dados.current.addresses[0].village = e.value);
        set_dados(dados)
    }



    const change_district_by_city = async e => {

        return await Utils.obter_distrito_por_cidade(e.value)
            .then(res =>
                change_district({ value: res })
            ).catch(() => { return } /* alert('Distrito não encontrado!') */)
    }



    const handle_change_addresses = (e, addresses_index = 0) => {
        const { name, value } = e.target;
        set_dados(dados.current.addresses[addresses_index][name] = value)
    }



     const handle_change_info_espap = e => {
        const { name, value } = e.target;
        set_dados(dados.current.info.espap[name] = value)
    }

    const handle_change_info_legacy_access = e => {
        const { name, value } = e.target;
        set_dados(dados.current.info.legacy_access[name] = value)
    }

    

    const handle_change_info = (e) => {
        const { name, value } = e.target;

        if (name === 'name') {
            set_dados(dados.current.info.company = value);
        }

        set_dados(dados.current.info[name] = value)

        if ((is_edit === false) && (name === 'vat')) {
            if (dados.current.info['vat'].length === 9) {
                load_entity(dados.current.info['vat'], Company.object_type)
            }
        }

    }

    const handle_change_contacts = (e, index = 0) => {
        const { name, value } = e.target;

        set_dados(dados.current.contacts[index][name] = value)

    }
    // ------------------------------------------------------------------------------------



    return isloading ? 
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">LOADING</h2>
                <p>LOADING</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>
            </div>
        </main>
    :
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language(lang).Company.name}</h2>
                <p><>
                    <NavLink to={'/'}>{language(lang).Company.path_home}</NavLink>{' / '}
                    <NavLink to={Company.components.base.path}>{language(lang).Company.name}</NavLink>{' / '}
                    {language(lang).Company.path_regist}
                </>
                </p>
            </div>


            <div className={`dash-cards-2 body`}>
                <div className="card">
                    <div className="card-body">
                        <form className={show_vat_form} id="form-vat" onSubmit={handle_submit_vat}>
                            <div className="form-group">
                                <span className="flex-1">
                                    {/*<input type="text" name="dados.info.vat" value={dados.info.vat} pattern="[0-9]{9}" className="input-form" placeholder="Introduza o NIF" onChange={e => set_dados({ ...dados, info: { ...dados.info, vat: e.target.value } })} required /> */}
                                    <input type="text" pattern={Utils.pattern_vat} minLength="9" inputMode='numeric' name="vat" value={dados.current.info.vat} className="input-form" placeholder="Introduza o NIF" onChange={handle_change_info} required />
                                </span>
                                <span className="flex-1">
                                    <input type="submit" value="Pesquisar" />
                                </span>
                            </div>
                        </form>

                        <form id="form" onSubmit={handle_submit}>
                            <input type="hidden" name="id" value={dados.current.id} />

                            <h2 className="dash-title">Dados da Empresa</h2>
                            <div className="form-group">
                                <span className="flex-1">
                                    <label>Nome</label>
                                    <input type="text" name="name" value={dados.current.info.name} /* pattern="[a-zA-Z\u00C0-\u00FF ]+" */ className="input-form" placeholder="Introduza o nome" onChange={handle_change_info} required />
                                </span>
                                <span className="flex-1">
                                    <label>Nome Abreviado</label>
                                    <input type="text" name="name_mini" value={dados.current.info.name_mini} pattern="[a-zA-Z\u00C0-\u00FF ]+" className="input-form" placeholder="Introduza o nome" onChange={handle_change_info} />
                                </span>
                                <span className="flex-1">
                                    <label>NIF</label>
                                    <input type="text" pattern={Utils.pattern_vat} minLength="9" inputMode='numeric' name="vat"  value={dados.current.info.vat} className="input-form" placeholder="Número de Contribuinte" onChange={handle_change_info} required />
                                </span>
                            </div>
                            <div className="form-group">
                                <span className="flex-1">
                                    <label>Telefone</label>

                                    <PhoneInput
                                        defaultCountry="PT"
                                        placeholder="Introduza o número de telefone"
                                        value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
                                        onChange={e => set_dados(dados.current.contacts[0].phone = e)} />
                                    {/* <input type="tel" name="phone" value={dados.current.contacts[0].phone} pattern="[0-9]{9}" className="input-form" placeholder="Introduza o número de telefone" onChange={handle_change_contacts} /> */}
                                </span>
                                <span className="flex-1">
                                    <label>Telemóvel</label>
                                    <PhoneInput
                                        defaultCountry="PT"
                                        placeholder="Introduza o número de telemóvel"
                                        value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
                                        onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)} />
                                    {/* <input type="tel" name="mobile_phone" value={dados.current.contacts[0].mobile_phone} pattern="[0-9]{9}" className="input-form" placeholder="Introduza o telemóvel" onChange={handle_change_contacts} /> */}
                                </span>
                                <span className="flex-1">
                                    <label>E-mail</label>
                                    <input type="email" pattern={Utils.pattern_email} name="email" value={dados.current.contacts[0].email} className="input-form" placeholder="Introduza o e-mail" onChange={handle_change_contacts} />
                                </span>
                            </div>
                            <div className="form-group">
                                <span className="flex-1">
                                    <label>País</label>
                                    <Select
                                        className="div-select"
                                        options={countries}
                                        name="pais"
                                        value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
                                        placeholder={"Introduza o paí­s"}
                                        onChange={change_country}
                                        styles={custom_select_styles}
                                    />
                                </span>
                                <span className={`flex-1 ${show_district_city_village}`}>
                                    <label>Distrito</label>
                                    <Select
                                        className="div-select"
                                        options={districts}
                                        name="distrito"
                                        value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
                                        placeholder={"Introduza o distrito"}
                                        onChange={change_district}
                                        styles={custom_select_styles}
                                    />
                                </span>
                                <span className={`flex-1 ${show_district_city_village}`}>
                                    <label>Concelho</label>
                                    <Select
                                        className="div-select"
                                        options={cities}
                                        name="concelho"
                                        value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
                                        placeholder={"Introduza o concelho"}
                                        onChange={change_city}
                                        styles={custom_select_styles}
                                    />
                                </span>
                            </div>
                            <div className="form-group">
                                <span className={`flex-1 ${show_district_city_village}`}>
                                    <label>Freguesia</label>
                                    <Select
                                        className="div-select"
                                        options={villages}
                                        name="freguesia"
                                        value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
                                        placeholder={"Introduza a Freguesia"}
                                        onChange={change_village}
                                        styles={custom_select_styles}
                                    />
                                </span>
                                <span className={`flex-1 `}>
                                    <label>Localidade</label>
                                    <input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="input-form" placeholder="Introduza a Localidade" onChange={handle_change_addresses} required />
                                </span>
                                <span className="flex-1">
                                    <label>Código-postal</label>
                                    <input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="input-form" placeholder="Introduza o código-postal" onChange={handle_change_addresses} required />
                                </span>
                                <span className="flex-1">

                                </span>
                            </div>
                            <div className="form-group">
                                <span className="flex-2">
                                    <label>Morada</label>
                                    <textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="input-form" rows="4" onChange={handle_change_addresses} required>
                                    </textarea>
                                </span>
                                <span className="flex-1"></span>
                            </div>


                            <h2 className="dash-title">Legacy Connection</h2>
                            <div className="form-group">
                                <span className="flex-1">
                                    <label>Host (Name or IP)</label>
                                    <input type="text" name="host" value={dados.current.info.legacy_access.host} className="input-form" placeholder="Introduza o IP da Base de Dados" onChange={handle_change_info_legacy_access} required />
                                </span>
                            
                                <span className="flex-1">
                                    <label>Nome da base de dados</label>
                                    <input type="text" name="database" value={dados.current.info.legacy_access.database} className="input-form" placeholder="Introduza o IP da Base de Dados" onChange={handle_change_info_legacy_access} required />

                                </span>

                                <span className="flex-1">
                                    <label>Utilizador da base de dados</label>
                                    <input type="text" name="user" value={dados.current.info.legacy_access.user} className="input-form" placeholder="Introduza o IP da Base de Dados" onChange={handle_change_info_legacy_access} required />

                                </span>

                                <span className="flex-1">
                                    <label>Password da base de dados</label>
                                    <input type="text" name="password" value={dados.current.info.legacy_access.password} className="input-form" placeholder="Introduza o IP da Base de Dados" onChange={handle_change_info_legacy_access}  />

                                </span>

                            </div>

                           
                            <h2 className="dash-title">Dados ESPAP</h2>
                            <div className="form-group">

                                <span className="flex-1">
                                    <label>ESPAP Username</label>
                                    <input type="email" name="username" value={dados.current.info.espap.username} className="input-form" placeholder="Introduza a Utilizador ESPAP" onChange={handle_change_info_espap} required />
                                </span>

                                <span className="flex-1">
                                    <label>ESPAP Password</label>
                                    <input type="text" name="password" value={dados.current.info.espap.password} className="input-form" placeholder="Introduza a Password ESPAP" onChange={handle_change_info_espap} required />
                                </span>
                            </div>



                        </form>
                    </div>
                </div>
            </div>
 


            <div className={'dash-cards-2 footer'}>
                <nav className="navbar bottom-navbar navbar-light">
                    <div className="navbar-footer">
                        <ul className="navbar-nav float-left"></ul>
                        <ul className="navbar-nav float-right">
                            <li className="nav-item">
                                <NavLink className="nav-link btn-cancel" to={Company.components.list.path}  >

                                    <img alt='' src={Utils.repo_icons_link('cancelar.svg')} />
                                    <span>{language(lang).options.cancel}</span>
                                </NavLink>
                            </li>

                            <li className={"nav-item "}>
                                <button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">

                                    <img alt='' src={Utils.repo_icons_link('eliminar.svg')} />
                                    <span>{language(lang).options.delete}</span>
                                </button>
                            </li> 

                            <li className="nav-item">
                                <button type="submit" form="form" className="nav-link">

                                    <img alt='' src={Utils.repo_icons_link('save.svg')} />
                                    <span>{language(lang).options.save}</span>
                                </button>
                            </li>

                        </ul>
                    </div>
                </nav>
            </div>
			</main>

}
